'use strict';

// Vendors

// Modules
// import './module/formation';
// import './module/page_animations';
// import './module/social';
// import './module/scrollto';
// import Menu from './module/menu';
// import Popins from './module/popins';
// import Forms from './module/form/forms';
// import Accordion from './module/accordion';
// import TabsNav from './module/tabs_nav';
// import Carousel from './module/carousel';
// import MapToomtip from './module/map';
// import VideoPlayer from './module/video_player';
// import InfoBox from './module/info_box';
// import AutoComplete from './module/autocomplete';

// Helpers
// import Helpers from './module/helpers';

import objectFitImages from './vendor/ofi';

import './modules/popinOpeners';
import './modules/seoLinks';

import './helper/polyfill/arrayFrom';
import './helper/polyfill/arrayFind';
import './helper/polyfill/dataset';

import * as conditioner from 'conditioner-core/conditioner-core.min';

require('intersection-observer');
require('es6-promise').polyfill();

/* global IntersectionObserver */

document.documentElement.className = 'js';

// data-module="mainNavigation" data-context="@visible"
conditioner.addPlugin({
    // the plugin "monitor" hook
    monitor: {
    // the name of our monitor, not prefixed with "@"
        name: 'visible',

        // the monitor factory method, this will create our monitor
        create: (context, element) => ({
            // current match state
            matches: false,

            // called by conditioner to start listening for changes
            addListener (change) {
                new IntersectionObserver(entries => {
                    // update the matches state
                    this.matches = entries.pop().isIntersecting === context;

                    // inform conditioner of the new state
                    change();
                }).observe(element);
            }
        })
    },

    // converts module aliases to paths
    moduleSetName: name => `./modules/${name}.js`,

    // get the module constructor
    moduleGetConstructor: module => module.default,

    // override the import (this makes webpack bundle all the dynamically included files as well)
    // https://webpack.js.org/api/module-methods/#import-
    // - set to "eager" to create a single chunk for all modules
    // - set to "lazy" to create a separate chunk for each module
    moduleImport: name => import(/* webpackMode: "lazy" */ `${name}`)
});

conditioner.hydrate(document.documentElement);

// Object fit polyfill for IE
objectFitImages();



// WEBPACK FOOTER //
// ./front/js/app.js